<template lang="html">
    <div>
        <div class="d-flex flex-row py-2 border-bottom-medium">
            <div class="d-flex flex-column flex-grow-1 leftArea">
                <div class="fs-larger font-weight-600 darker">{{ticketLabel}}<span v-if="!hideCounter">:</span></div>
                <div class="fs-smaller dark">{{ticketPrice}}</div>
            </div>

            <div class="rightArea" v-if="!hideCounter">
                <button v-if="!disabled" :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="changePax('subtract', personPrice)"> - </button>
                <input
                    :disabled="disabled"
                    type="text"
                    class="text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-1"
                    style="width: 2rem;"
                    value="0"
                    v-model.number="personPrice.quantityToBook"
                    @input.lazy="paxManuallyChanged(personPrice)"
                    v-numInt
                />
                <button v-if="!disabled" :disabled="disabled" class="btn fs-large bg-lightest dark border-medium py-0 px-2 h-100" @click="changePax('add', personPrice)"> + </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations';

    export default {
        mixins: [
            reservationsMixin,
        ],
        data() {
            return {
                testValue: 0
            }
        },
        props: {
            personPrice: {
                type: Object,
                required: true
            },
            reservation: {
                type: Object,
                required: true
            },
            isEditing: {
                type: Boolean,
                default: false
            }
        },
        created() {
            // save the original quantityToBook value, this will allow us to increment and decremtent
            // pax BUT prevent it to go lower that the original value
            this.testValue = this.personPrice.quantityToBook;
        },
        computed: {
            hideCounter() {
                return this.personPrice.audienceType == null;
            },
            disabled() {
                return this.personPrice.genderPriceType == null || !this.isEditing;
            },
            ticketLabel() {
                if (!this.personPrice.audienceType && !this.personPrice.audienceTypeDescription) {
                    return 'Ticket';
                } else {
                    return this.personPrice.audienceTypeLabel? this.personPrice.audienceTypeDescription + ' - ' + this.personPrice.audienceTypeLabel : this.personPrice.audienceTypeDescription;
                }
            },
            ticketPrice() {
                return this.personPrice.grossprice > 0 ? this.formatPrice(this.personPrice.grossprice)+'€' : 'Free';
            },
            transportDiference() {
                const totalPax = this.reservation.bookingGenderPrices.reduce((acc, comp) => acc + comp.quantityToBook, 0);
                const totalTransport = this.reservation.bookingComponents.reduce((acc, comp) => acc + (comp.component.componentType === 1 ? comp.quantity : 0), 0);

                return totalTransport > 0 && totalPax !== totalTransport;
            }
        },
        methods: {
            changePax(operation, personPrice) {
                let quantityAvailable = this.reservation.event.maximumLotation - this.reservation.event.quantityBooked;
                let quantityPerTicket = personPrice.audienceTypeOccupancy? personPrice.audienceTypeOccupancy : 1;
                
                if (operation == 'add') {
                    if (quantityAvailable - quantityPerTicket >= 0 || this.reservation.event.maximumLotation == -1) {
                        this.reservation.event.quantityBooked+= Number(quantityPerTicket);

                        if (this.reservation.event.rejectBookingBasedOnMinMax && this.reservation.event.maximumPaxPerBooking != 0  && !this.accessPermissionFilter(['admin'])) {
                            let total = 0

                            for (let personTypes of this.reservation.bookingGenderPrices) {
                                total += personTypes.quantityToBook
                            }

                            let totalPaxRule = total + quantityPerTicket

                            if (totalPaxRule <= this.reservation.event.maximumPaxPerBooking) {
                                personPrice.quantityToBook++;
                            } else {
                                this.$toasted.info(`A maximum of  ${this.reservation.event.maximumPaxPerBooking}  PAX per booking is required.`);
                            }
                        } else{
                            personPrice.quantityToBook++;
                        }
                    } else {
                        this.$toasted.info('Event has no more available Pax.');
                    }
                } else {
                    if (personPrice.quantityToBook > 0) {
                        if (this.reservation.event.rejectBookingBasedOnMinMax && this.reservation.event.minimumPaxPerBooking != 0  && !this.accessPermissionFilter(['admin'])) {
                            let total = 0
                            
                            for (let personTypes of this.reservation.bookingGenderPrices) {
                                total += personTypes.quantityToBook
                            }

                            let totalPaxRule = total - quantityPerTicket
                            
                            if (totalPaxRule >= this.reservation.event.minimumPaxPerBooking) {
                                this.reservation.event.quantityBooked--;
                                personPrice.quantityToBook--;
                            } else {
                                this.$toasted.info(`A minimum of ${this.reservation.event.minimumPaxPerBooking} PAX per booking is required.`);
                            }
                        } else{
                            this.reservation.event.quantityBooked--;
                            personPrice.quantityToBook--;
                        }
                    } else {
                        this.$toasted.info('Unable to update the reservation to 0 guests.');
                    }
                }

                // If there is associated transport and more people are added or removed, the following message is displayed 
                if (this.transportDiference) {
                    this.$toasted.error('Edit transport!', {  
                            duration: 3500, 
                            action: {
                                text: 'X',
                                onClick: (e, toastObject) => {
                                    toastObject.goAway(0);
                                },
                                class: 'p-0 pl-1 font-weight-700'
                            },
                        }
                    );
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .leftArea{
        line-height: 1.2em;
    }

    .rightArea{
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// reservationTicketPrice.vue?7083ae51